import { css, RuleSet } from 'styled-components';

import { TextStyles } from '../types';

export const DEFAULT_FONT_STYLE: Record<TextStyles, RuleSet> = {
    'lib-h1': css`
        font-size: 40px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 900;
        line-height: 52px;
    `,
    'lib-h2': css`
        font-size: 36px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 700;
        line-height: 44px;
    `,
    'lib-h3': css`
        font-size: 32px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 700;
        line-height: 40px;
    `,
    'lib-h4': css`
        font-size: 28px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 700;
        line-height: 36px;
    `,
    'lib-h5': css`
        font-size: 24px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 700;
        line-height: 32px;
    `,
    'lib-h6': css`
        font-size: 21px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 700;
        line-height: 32px;
    `,
    'lib-h1-medium': css`
        font-size: 40px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 500;
        line-height: 52px;
    `,
    'lib-h2-medium': css`
        font-size: 36px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 500;
        line-height: 44px;
    `,
    'lib-h3-medium': css`
        font-size: 32px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 500;
        line-height: 40px;
    `,
    'lib-h4-medium': css`
        font-size: 28px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 500;
        line-height: 36px;
    `,
    'lib-h5-medium': css`
        font-size: 24px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 500;
        line-height: 32px;
    `,
    'lib-h6-medium': css`
        font-size: 21px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 500;
        line-height: 32px;
    `,
    'lib-link': css`
        font-size: 12px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 400;
        line-height: 16px;
        text-decoration: underline;
    `,
    'lib-overline': css`
        font-size: 12px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 1px;
        text-transform: uppercase;
    `,
    'lib-medium-text': css`
        font-size: 16px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 400;
        line-height: 24px;
    `,
    'lib-caption-bold': css`
        font-size: 12px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 700;
        line-height: 16px;
    `,
    'lib-large-text': css`
        font-size: 18px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 400;
        line-height: 28px;
    `,
    'lib-small-text': css`
        font-size: 14px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 400;
        line-height: 20px;
    `,
    'lib-small-button': css`
        font-size: 14px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 1px;
        text-transform: uppercase;
    `,
    'lib-caption-smallest': css`
        font-size: 8px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 400;
        line-height: 10px;
    `,
    'lib-caption-small': css`
        font-size: 10px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 400;
        line-height: 12px;
    `,
    'lib-medium-button': css`
        font-size: 17px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 2px;
        text-transform: uppercase;
    `,
    'lib-caption-medium': css`
        font-size: 12px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 500;
        line-height: 16px;
    `,
    'lib-caption': css`
        font-size: 12px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 400;
        line-height: 16px;
    `,
    'lib-large-text-bold': css`
        font-size: 18px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 700;
        line-height: 28px;
    `,
    'lib-small-text-bold': css`
        font-size: 14px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 700;
        line-height: 20px;
    `,
    'lib-medium-text-bold': css`
        font-size: 16px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 700;
        line-height: 24px;
    `,
    'lib-large-text-medium': css`
        font-size: 18px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 500;
        line-height: 28px;
    `,
    'lib-small-text-medium': css`
        font-size: 14px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 500;
        line-height: 20px;
    `,
    'lib-medium-text-medium': css`
        font-size: 16px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 500;
        line-height: 24px;
    `,
    'lib-option-title-large-text': css`
        font-size: 18px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 700;
        line-height: 28px;
    `,
    'lib-option-title-medium-text': css`
        font-size: 16px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 700;
        line-height: 24px;
    `,
    'lib-option-title-small-text': css`
        font-size: 14px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 700;
        line-height: 20px;
    `,
    'lib-option-subtitle-text': css`
        font-size: 14px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 400;
        line-height: 20px;
    `,
    'lib-option-label': css`
        font-size: 12px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 1px;
        text-transform: uppercase;
    `,
    'lib-default': css`
        font-size: 16px;
        font-style: normal;
        font-family: 'Roboto';
        font-weight: 400;
        line-height: 24px;
    `,
};
